import Vue from 'vue';
import VueRouter from 'vue-router';
import ScreentCmsRouter from './screenCmsRouter' // 数字大屏-运维系统

Vue.use(VueRouter)
const router = new VueRouter({
  routes: [
  {
    path: '/',
    name: '/',
    redirect: '/login',
    hidden: false,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/ScanBear',
    name: 'ScanBear',
    meta: {
      title: '质量追溯'
    },
    component: () => import('../views/ScanInfo/ScanBear.vue'),
  },
  {
    path: '/scanDetail',
    name: 'scanDetail',
    meta: {
      title: '大型生产设备信息'
    },
    component: () => import('../views/ScanInfo/ScanDetail.vue'),
  },
  {
    path: '/reinInfo',
    name: 'reinInfo',
    meta: {
      title: '钢筋笼信息'
    },
    component: () => import('../views/ScanInfo/ReinInfo.vue'),
  },
  {
    path: '/massInfo',
    name: 'massInfo',
    meta: {
      title: '模具信息'
    },
    component: () => import('../views/ScanInfo/MassInfo.vue'),
  },
  {
    path: '/chainInfo',
    name: 'chainInfo',
    meta: {
      title: '连锁块信息'
    },
    component: () => import('../views/ScanInfo/ChainInfo.vue'),
  },
  {
    path: '/changeCompany',
    name: 'changeCompany',
    meta: {
      title: '首页'
    },
    component: () => import('../views/HomeIndex/ChangeCompany.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: () => import('../views/LoginIndex/index'),
  },
   {
    path: '/404',
    name: '404',
    hidden: false,
    component: () => import('../views/ErrorIndex/index'),
    meta: {
      title: '404'
    }
  },
  {
    path: '*',
    name: 'red-404',
    hidden: false,
    redirect: '/404',
    meta: {
      title: '404'
    }
  },
  ...ScreentCmsRouter]
})

export default router